import { useEffect, useState } from "react";

export default function HeroBanner({ banners }) {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    if (!banners.length) return;

    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setIndex(prev => (prev + 1) % banners.length);
        setFade(true);
      }, 300);
    }, 3500);

    return () => clearInterval(interval);
  }, [banners]);

  return (
    <div className="hero-banner">

      {banners.length > 0 && (
        <img
          src={banners[index]?.image}
          alt="banner"
          className={`hero-img ${fade ? "fade-in" : "fade-out"}`}
        />
      )}

      {/* DOTS */}
      <div className="hero-dots">
        {banners.map((_, i) => (
          <span
            key={i}
            className={i === index ? "dot active" : "dot"}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  );
}